module.exports = __webpack_public_path__ + "static/check1-ec76f796430e637b83064ba775d74c5c.png";